export interface PreferencesMetaData {
  channel_details: ChannelMeta[];
}

export interface ChannelMeta {
  name: string;
  value: string;
  enabled: boolean;
  reason?: string;
}

export interface RawPreference {
  severity: SeverityType;
  name: string;
  alert_type: string;
  group: string;
  description: string;
  alert_channel_preference: {
    email_enabled: boolean;
  };
}

export interface Preference {
  severity: SeverityType;
  name: string;
  type: string;
  group: string;
  description: string;
  configs: {
    email: boolean;
  };
}

export enum SeverityType {
  CRITICAL = 'CRITICAL',
  WARNING = 'WARNING'
}
